export function doesLinkExist(link) {
  try {
    return link.youtube_link.url
  } catch (e) {
    return false
  }
}
